import React from 'react'
import { string, oneOfType, node } from 'prop-types'
import {
  button,
  text,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'
import ExternalLink from '@groovehq/internal-design-system/lib/assets/icons/ExternalLink'
import Scenery from '@groovehq/internal-design-system/lib/assets/icons/Scenery'
import { styles } from './Product.styles'

const Product = ({ image, name, productURl, children, className }) => {
  const rootClassName = ['grui flex items-center', className].join(' ')
  return (
    <div className={rootClassName}>
      <div css={styles.imgBox}>
        {image ? <img src={image} alt={name} /> : <Scenery />}
      </div>
      <div className="grui ml-7 overflow-hidden">
        {productURl ? (
          <a
            css={[button.styles.link, text.styles.fontMedium, styles.link]}
            className="grui flex items-center"
            href={productURl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="grui truncate">{name}</span>
            <ExternalLink className="grui flex-shrink-0" />
          </a>
        ) : (
          <p
            className="grui truncate"
            css={[
              paragraph.styles.preflight,
              text.styles.textBlack,
              text.styles.fontMedium,
            ]}
          >
            {name}
          </p>
        )}
        {children && (
          <p
            className="grui truncate"
            css={[
              paragraph.styles.preflight,
              text.styles.textXs,
              text.styles.textDark,
              text.styles.fontNormal,
            ]}
          >
            {children}
          </p>
        )}
      </div>
    </div>
  )
}

Product.propTypes = {
  image: string,
  name: string,
  productURl: string,
  children: oneOfType([string, node]),
  className: string,
}

Product.defaultProps = {
  image: undefined,
  name: '',
  productURl: undefined,
  children: undefined,
  className: undefined,
}

export default Product
